/* eslint-disable */ import { assertString, attributeSelectionComponent, materialSwatchComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const withDesignComponents = [
    attachComponent.withComponent(attributeSelectionComponent, 'collection', true).withAlias('WithDesign').attach(memoEval((self)=>[
            self.$collectionOptions,
            self.collection
        ], ($collectionOptions, collection)=>({
            options: $collectionOptions,
            value: collection
        })), (state)=>{
        assertString(state.value);
        return {
            collection: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'texture', true).withAlias('WithDesign').attach(memoEval((self)=>[
            self.$textureOptions,
            self.design
        ], ($textureOptions, design)=>({
            options: $textureOptions,
            value: design
        })), (state)=>{
        assertString(state.value);
        return {
            design: state.value
        };
    }),
    attachComponent.withComponent(materialSwatchComponent, 'color', true).withAlias('WithDesign').attach(memoEval((self)=>[
            self.design,
            self.$colorSwatches
        ], (design, $colorSwatches)=>({
            selectedSwatchKey: design,
            swatches: $colorSwatches
        })), (state)=>{
        assertString(state.selectedSwatchKey);
        return {
            design: state.selectedSwatchKey
        };
    })
];

//# sourceMappingURL=with-design.js.map